import stylesGlobal from '../../screens/style';

const styles = {
  text: {
    color: stylesGlobal.neutral900,
    fontFamily: 'Lato',
  },
};

export default styles;
